import React from 'react';
import { Note, NOTE_FLAGS } from '../../models/Note';
import { Badge } from '../primitives';

interface NewsBadgeProps {
  note: Note;
  className?: string;
}

/**
 * A reusable component to display a NEWS badge for notes
 */
const NewsBadge: React.FC<NewsBadgeProps> = ({ note, className = '' }) => {
  if (!NOTE_FLAGS.hasFlag(note, NOTE_FLAGS.NEWS)) {
    return null;
  }

  return (
    <Badge variant="warning" className={className}>
      NEWS
    </Badge>
  );
};

export default NewsBadge;
